import { Scale } from "lucide-react";
import { COMPLIANCE_TEXT } from "@/components/fleet/legalContent";
import { EscrowSeal } from "@/components/fleet/EscrowSeal";

const LINKS = [
  { id: "tc", label: "Termini e Condizioni B2B (T&C)", testid: "footer-tc-link" },
  { id: "privacy", label: "Privacy & Cookie Policy (GDPR EU)", testid: "footer-privacy-link" },
  { id: "escrow", label: "Garanzia Deposito Sicuro (Escrow Protection)", testid: "footer-escrow-link" },
  { id: "license", label: "Verifica Licenza / Flotta", testid: "footer-verification-link" },
];

export const Footer = ({ onOpenLegal }) => (
  <footer className="border-t border-[#27272A] bg-black" data-testid="legal-footer">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10 flex flex-col gap-6">
      <EscrowSeal testid="footer-escrow-seal" />
      <div className="ff-card p-5 flex gap-4 items-start">
        <Scale size={22} className="text-[#3B82F6] shrink-0 mt-0.5" />
        <p data-testid="footer-compliance-text" className="text-sm sm:text-base text-white leading-relaxed">{COMPLIANCE_TEXT}</p>
      </div>
      <nav className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1">
        {LINKS.map((l) => (
          <button key={l.id} type="button" data-testid={l.testid} onClick={() => onOpenLegal(l.id)} className="text-left text-sm font-semibold text-[#94A3B8] hover:text-white transition-colors min-h-[44px]">
            {l.label}
          </button>
        ))}
      </nav>
      <span className="text-xs font-semibold uppercase tracking-[0.1em] text-[#52525b]">© {new Date().getFullYear()} FLEETFLOW • B2B Network</span>
    </div>
  </footer>
);
